import blackboardlogo from "./blackboard-logo.png";

export const Blackboard = () => {
  return <img src={blackboardlogo} height={100} />;
};
